import { useTenantAuth } from "../../../../../context/TeanantAuthProvider";
import CommonLoader from "../../../../common/CommonLoader";
import { SchoolSessionForm } from "../SessionForm";

/**
 * AdminProfilePage - Settings page content for Admin Profile
 * Renders inside SettingsLayout via Outlet
 */
const SchoolSessionPage = () => {
  const { currentUser, loading } = useTenantAuth();

  return (
    <div className="row">
      {loading ? (
        <CommonLoader loadingMessage="Loading session..." />
      ) : (
        <SchoolSessionForm users={currentUser} />
      )}
    </div>
  );
};

export default SchoolSessionPage;
